import { Bell } from "lucide-react"
import { Breadcrumb } from "@/components/layout/Breadcrumb"
import { Card, CardContent } from "@/components/ui/card"

export function NotificationsPage() {
  return (
    <>
      <Breadcrumb />
      <div className="flex flex-col items-center justify-center flex-1 px-4 min-h-[calc(100vh-8rem)]">
        <Card className="w-full max-w-sm">
          <CardContent className="flex flex-col items-center gap-6 pt-8 pb-8 text-center">
            {/* Icon */}
            <div className="w-16 h-16 rounded-full bg-[#0014cc] flex items-center justify-center">
              <Bell className="w-8 h-8 text-white" strokeWidth={1.5} />
            </div>

            {/* Text */}
            <div className="space-y-2">
              <p className="text-lg font-semibold text-slate-800">Notifications coming soon</p>
              <p className="text-sm text-slate-500 leading-relaxed">
                You'll be able to see status changes, preview approvals, and campaign updates all in one place.
              </p>
            </div>

            {/* Placeholder items */}
            <div className="w-full space-y-2">
              {[
                { label: "Preview approved", sub: "Ford Mustang · Meta 1:1", dot: "bg-green-400" },
                { label: "Action required", sub: "Ford Puma · Ad Copy Creation", dot: "bg-amber-400" },
                { label: "Campaign live", sub: "Ford Explorer · TikTok 9:16", dot: "bg-[#0014cc]" },
              ].map((item) => (
                <div
                  key={item.label}
                  className="flex items-center gap-3 rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 text-left opacity-40 select-none"
                >
                  <span className={`h-2 w-2 rounded-full flex-shrink-0 ${item.dot}`} />
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-slate-800 truncate">{item.label}</p>
                    <p className="text-xs text-slate-400 truncate">{item.sub}</p>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  )
}
